import { render, staticRenderFns } from "./chartersservice.vue?vue&type=template&id=51f07084"
import script from "./chartersservice.vue?vue&type=script&lang=js"
export * from "./chartersservice.vue?vue&type=script&lang=js"
import style0 from "./chartersservice.vue?vue&type=style&index=0&id=51f07084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports